import React from 'react'
import FilterForm from './FilterForm'

export const FilterContainer = () => {
  return (
    <div className="mt-5">
      <h4>Filters</h4>
      <FilterForm />
    </div>
  )
}
